import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-standard-gridview',
  templateUrl: './standard-gridview.component.html',
  styleUrls: ['./standard-gridview.component.css']
})
export class StandardGridviewComponent implements OnInit {

  private _lstData: any[];
  @Input() set lstData(value: any[]) {
    this._lstData = value;
    this.totalPages = Math.ceil(this.lstData.length / this.recordsPerPage);
    this.currentPage = 1;    
  }
  get lstData(): any[] {
    return this._lstData;
  }

  @Input() columnsToHide: any = [];
  @Input() gridTitle: string = "";
  @Input() showExcelDownloadOption: boolean = true;
  @Input() showSearchOption: boolean = true;
  @Input() showRecordsPerPageOption: boolean = true;
  @Input() showPagination: boolean = true;
  @Input() showScrollButton: boolean = true;
  @Input() showOuterBox: boolean = true;
  @Input() showRefreshButton: boolean = false;
  @Input() recordsPerPage = 5;
  @Input() hyperlinkCols: any = ['attachment', 'urn'];

  @Output() cellClickEvent = new EventEmitter<any>();
  @Output() RefreshEvent = new EventEmitter<any>();

  @ViewChild('scrollableGrid') scrollableGrid: ElementRef;

  searchInput: string = '';
  lstFilteredData: any = [];
  lstColumns: any = [];
  currentPage = 1;
  totalPages = 1;
  sortColumnInfo = { name: '', isOrderAsc: true };

  selectedColIndex: number = -1;
  selectedRowIndex: number = -1;

  constructor(private commonService: CommonService) {

  }

  ngOnInit(): void {
    
    this.totalPages = Math.ceil(this.lstData.length / this.recordsPerPage);
    if (this.lstData.length > 0)
      this.lstColumns = Object.keys(this.lstData[0]);
    this.lstFilteredData = this.lstData;

  }

  onCellClick(columnName: String, rowData: any, rowIndex: number) {
    this.cellClickEvent.emit({ columnName: columnName, rowData: rowData, rowIndex });
  }

  getCellStyle(col: string): Object {
    if (this.hyperlinkCols.includes(col.toLowerCase())) {
      return { 'cursor': 'pointer', 'text-decoration': 'underline', 'color': '#76449b', 'font-weight': 600 };
    } {
      return {};
    }
  }

  scrollGrid(direction: string): void {
    if (direction == 'next') {
      this.scrollableGrid.nativeElement.scrollLeft += 500;
    } else {
      this.scrollableGrid.nativeElement.scrollLeft -= 500;
    }

  }

  sortByColumn(column: string) {
    let sortOrder = false;
    if (this.sortColumnInfo.name == column)
      sortOrder = !this.sortColumnInfo.isOrderAsc;
    else
      this.sortColumnInfo.name = column;

    this.sortColumnInfo.isOrderAsc = sortOrder;

    if (sortOrder)
      this.lstData.sort((a, b) => a[column] < b[column] ? -1 : a[column] > b[column] ? 1 : 0);
    else
      this.lstData.sort((a, b) => b[column] < a[column] ? -1 : b[column] > a[column] ? 1 : 0);
  }

  changePage(direction: string) {
    if (direction == 'prev')
      this.currentPage = this.currentPage == 1 ? 1 : this.currentPage - 1;
    if (direction == 'next')
      this.currentPage = this.currentPage == this.totalPages ? this.totalPages : this.currentPage + 1;
  }

  changeRecordsPerPage() {
    this.totalPages = Math.ceil(this.lstFilteredData.length / this.recordsPerPage);
    this.currentPage = 1;
  }

  onSearchChange() {
    this.lstFilteredData = this.lstData.filter(x => {
      let isContains = false;
      this.lstColumns.forEach(c => {
        if (x[c].toString().toLowerCase().includes(this.searchInput)) { isContains = true; }
      });
      return isContains;
    });
    this.changeRecordsPerPage();
  }

  downloadExcel() {
    this.commonService.exportAsExcelFile(this.lstFilteredData, 'status-report');
  }
  onSelectionChange(event: any, index: number, colName: string) {

    this.lstFilteredData[index][colName].forEach(element => {
      element.selected = false;
    })
    let currentIndex = this.lstFilteredData[index][colName].findIndex(a => a.value === event.value)
    this.lstFilteredData[index][colName][currentIndex].selected = true;

  }

  multiSelect_Dropdown_change_Event(event: any, columnName: String, rowData: any, rowIndex: number) {
    rowData["" + columnName + ""].value = event.selectedValues;
    this.onCellClick(columnName, rowData, rowIndex);
  }
}
